export default __webpack_public_path__ + "static/popup-6279263a4fb2ae9e4b5b54ede3630d93.png";